<template>
  <icon v-if="cart?.icon" name="icon:bag" class="h-22px w-22px cursor-pointer text-xl" />
  <icon v-else name="icon:shop-cart" class="h-22px w-22px cursor-pointer text-xl" />
</template>

<script lang="ts" setup>
const { page } = storeToRefs(useThemeEditorStore())
const cart = computed(() => page.value?.settings?.global?.cart)
</script>

<style></style>
